function Page({ children }) {
  return (
    <div className="w-[794px] h-[1123px] bg-white mx-auto mb-3 overflow-hidden shadow-[0_0_40px_10px_rgba(0,0,0,0.5)]">
  {children}
</div>
  );
}

export default Page;